import Vue from 'vue'
import App from './App.vue'
// 引入axios
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
// 引入store
import store from '@/store/index.js'
// 引入vue-router
import router from './router'
// 引入elemeUIEvent
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {
	addColor
} from '../src/style/configColor.js'
import '@/style/new_file.css'
import 'vant/lib/index.css'
addColor()
Vue.use(VueQuillEditor, /* { 默认全局 } */ )

// 挂载element ui
Vue.use(ElementUI);
// 阻止启动生产消息
Vue.config.productionTip = false
Vue.use(Vant);
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')